export function isCboMedico(codigoCbo: string): boolean {
  return CBO_MEDICO.find((cbo) => codigoCbo.startsWith(cbo))?.length > 0
}

export function isCboCirurgiaoDentista(codigoCbo: string): boolean {
  return CBO_CIRURGIAO_DENTISTA.find((cbo) => codigoCbo.startsWith(cbo))?.length > 0
}

export function isCboProcedimento(codigoCbo: string): boolean {
  return CBO_PROCEDIMENTO.find((cbo) => codigoCbo.startsWith(cbo))?.length > 0
}

export function isCboMedicoOuCirurgiaoDentista(codigoCbo: string): boolean {
  return isCboMedico(codigoCbo) || isCboCirurgiaoDentista(codigoCbo)
}

const CBO_MEDICO = ['2251', '2252', '2253', '2231F9']
const CBO_CIRURGIAO_DENTISTA = ['2232']

// Todos os CBOs que não estão nessa lista são considerados de nível superior
const CBO_PROCEDIMENTO = [
  '515110',
  '322230',
  '322250',
  '322235',
  '322240',
  '324210',
  '322205',
  '322245',
  '322210',
  '322215',
  '322220',
]
